/**
 * Map visualization types for Diplomacy
 */
/**
 * Available map styles
 */
export const MAP_STYLES = [
    {
        id: 'classic',
        name: 'Classic',
        description: 'Traditional Diplomacy map style',
        available: true,
    },
    {
        id: 'modern',
        name: 'Modern',
        description: 'Clean, modern styling (coming soon)',
        available: false,
    },
];
//# sourceMappingURL=map.js.map